<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="sidebar-comments-component" toastContainer>
  <div class="search-button-wrapper">
    <button
      class="btn btn-comment-type btn-search-trigger ms-auto"
      tooltipClass="tooltip-z-index"
      container="body"
      [ngbTooltip]="'COMMENTS.SEARCH.TRIGGER_SEARCH_BUTTON_TOOLTIP' | translate"
      *ngIf="!showSearch"
      (click)="toggleSearch()"
    >
      <i class="far fa-search"></i>
    </button>
  </div>
  <div class="search-wrapper" [formGroup]="formSearch" *ngIf="showSearch">
    <label for="comment-textarea">{{ 'COMMENTS.SEARCH.SEARCH_COMMENTS_LABEL' | translate }}</label>
    <input id="comment-search" class="form-control" formControlName="comment" />
    <div class="form-bottom">
      <div
        class="btn-group btn-group-toggle d-flex justify-content-between w-100"
        ngbRadioGroup
        name="type_id"
        formControlName="type_id"
      >
        <div ngbDropdown class="d-inline-block">
          <button
            class="btn btn-outline-primary btn-types-search"
            id="dropdownBasic1"
            ngbDropdownToggle
            tooltipClass="tooltip-z-index"
            container="body"
            [ngbTooltip]="'COMMENTS.SEARCH.TYPE_DROPDOWN_TOOLTIP' | translate"
          >
            <span class="comment-type-icon" [ngClass]="selectedSearchType" *ngIf="selectedSearchType"></span>
            {{ (selectedSearchType ? selectedSearchType : ('COMMENTS.SEARCH.TYPE_DROPDOWN' | translate)) | titlecase }}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <label ngbButtonLabel ngbDropdownItem (click)="searchTypeChange(null)">
              <input ngbButton type="radio" [value]="null" />
              <span>{{ 'COMMENTS.SEARCH.ALL_BUTTON' | translate }}</span>
            </label>
            <label ngbButtonLabel ngbDropdownItem *ngFor="let type of types" (click)="searchTypeChange(type.value)">
              <input ngbButton type="radio" [value]="type.id" />
              <span class="comment-type-icon" [ngClass]="type.value"></span>
              <span>{{ type.value | titlecase }}</span>
            </label>
          </div>
        </div>
        <button class="btn btn-outline-primary btn-submit-search" (click)="search()">
          {{ 'COMMENTS.SEARCH.SUBMIT_BUTTON' | translate }}
        </button>
        <button class="btn btn-danger btn-clear" (click)="clearSearch()">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <div [formGroup]="form">
    <label for="comment-textarea">{{ 'COMMENTS.ADD_COMMENT' | translate }}</label>
    <!--    <textarea-->
    <!--      id="comment-textarea"-->
    <!--      class="form-control comment-textarea"-->
    <!--      formControlName="comment"-->
    <!--      pInputTextarea-->
    <!--      autoResize="true"-->
    <!--      (keydown)="whisper($event)"-->
    <!--    ></textarea>-->

    <textarea
      id="comment-textarea"
      class="form-control comment-textarea fw-normal"
      formControlName="comment"
      pInputTextarea
      autoResize="true"
      (change)="onChange()"
    ></textarea>

    <div class="form-bottom">
      <div class="btn-group btn-group-toggle">
        <ng-container *ngFor="let type of types">
          <label
            class="btn btn-comment-type"
            *ngIf="type.id !== CommentsTypes.note"
            [class.active]="form.get('type_id').value === type.id"
            (click)="form.get('type_id').setValue(type.id)"
            [ngbTooltip]="type.value"
            tooltipClass="tooltip-z-index"
            container="body"
          >
            <span class="comment-type-icon" [ngClass]="type.value"></span>
          </label>
        </ng-container>
      </div>

      <input type="color" formControlName="color" class="color-picker-custom" />

      <button
        type="button"
        id="btn-submit-comment"
        class="btn btn-secondary btn-xs"
        (click)="postComment()"
      >
        {{ 'COMMENTS.POST' | translate }}
      </button>
    </div>
  </div>

  <!--  <div *ngIf="usersTyping.length">
      <span *ngFor="let user of usersTyping; let i = index">
        {{ user?.fake_first_name }} {{ user?.fake_first_name }} <span *ngIf="i + 1 !== usersTyping.length">,</span>
      </span>

      <div class="waves">
        <span class="circle wave-toggle"></span>
        <span class="circle wave-toggle"></span>
        <span class="circle wave-toggle"></span>
      </div>
    </div>-->

  <div class="comments-wrapper mt-3">
    <div class="separator"></div>

    <div class="comments-actions">
      <div class="collapse-button-wrapper">
        <button
          class="btn btn-comment-type btn-collapse-comments"
          [ngClass]="{ active: this.commentsExpanded }"
          type="button"
          (click)="expandAll()"
        >
          <i class="fal fa-expand-alt"></i>
        </button>
      </div>
      <div class="refresh-button-wrapper">
        <button class="btn btn-comment-type btn-refresh-comments" type="button" (click)="loadData(1)">
          <i class="far fa-sync-alt"></i>
        </button>
      </div>
    </div>

    <div *ngIf="commentsResponse && commentsResponse.data && commentsResponse.data.length <= 0" class="mb-3">
      {{ 'COMMENTS.NO_COMMENTS_MSG' | translate }}
    </div>

    <div class="single-comment" *ngFor="let comment of commentsResponse.data; let i = index">
      <div class="row">
        <div class="col-sm-2">
          <div
            class="comment-type-icon-holder"
            [ngbTooltip]="comment.type.value"
            tooltipClass="tooltip-z-index"
            container="body"
          >
            <span class="comment-type-icon" [ngClass]="comment.type.value"></span>
          </div>
        </div>
        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-7">
              <div>
                <span *ngIf="!comment.user"> System user </span>
                <app-user-box *ngIf="comment.user" [user]="comment.user"></app-user-box>
              </div>
            </div>

            <div class="col-sm-5 text-end">
              <ng-template #tipContent>
                <i class="fal fa-clock"></i>
                {{ comment.created_at.getTime() }}
              </ng-template>
              <div class="comment-date" container="body" tooltipClass="tooltip-z-index" [ngbTooltip]="tipContent">
                {{ comment.created_at.getDate() }}
              </div>
            </div>

            <div class="col-sm-12 mb-3">
              <div class="comment">
                <div class="form-bottom" *ngIf="comment.meta_front.edit">
                  <div class="btn-group btn-group-toggle">
                    <ng-container *ngFor="let type of types">
                      <button
                        *ngIf="type.id !== CommentsTypes.note"
                        [attr.aria-label]="type.value"
                        type="button"
                        class="btn btn-comment-type"
                        [class.active]="comment.type_id === type.id"
                        (click)="comment.type_id = type.id"
                        [ngbTooltip]="type.value"
                        tooltipClass="tooltip-z-index"
                        container="body"
                      >
                        <span class="comment-type-icon" [ngClass]="type.value"></span>
                      </button>
                    </ng-container>
                  </div>

                  <input type="color" [(ngModel)]="comment.color" class="color-picker-custom" />
                </div>

                <div
                  class="comment-content"
                  #commentContent
                  *ngIf="!comment.meta_front.edit"
                  [innerHTML]="comment.commentHTML"
                  [ngClass]="!comment.meta_front.expand ? 'collapsed' : 'expanded'"
                  [style.color]="comment.colorHex"
                ></div>

                <textarea
                  *ngIf="comment.meta_front.edit"
                  class="edit-comment-textarea form-control fw-normal"
                  [(ngModel)]="comment.comment"
                  pInputTextarea
                  autoResize="true"
                ></textarea>
              </div>

              <div class="d-flex align-items-center justify-content-end">
                <small
                  *ngIf="!comment.meta_front.edit"
                  (click)="expandComment(comment)"
                  class="edit-comment pointer me-3"
                >
                  <ng-container *ngIf="comment.meta_front.expand">
                    {{ 'COMMENTS.COLLAPSE' | translate }}
                  </ng-container>
                  <ng-container *ngIf="!comment.meta_front.expand">
                    {{ 'COMMENTS.EXPAND' | translate }}
                  </ng-container>
                </small>

                <div
                  class="text-end"
                  *ngIf="auth?.accessToken?.profile?.id === comment?.user_id || isCurrentUserAdministrator"
                >
                  <small
                    *ngIf="!comment.meta_front.edit && comment.type_id !== CommentsTypes.note"
                    class="edit-comment pointer"
                    (click)="editComment(comment)"
                  >
                    {{ 'COMMENTS.EDIT' | translate }}
                  </small>

                  <small
                    *ngIf="!comment.meta_front.edit && comment.type_id !== CommentsTypes.note"
                    class="delete-comment pointer d-inline-block ms-3"
                    [swal]="{}"
                    (confirm)="deleteComment(comment)"
                  >
                    {{ 'COMMENTS.DELETE' | translate }}
                  </small>

                  <small *ngIf="comment.meta_front.edit" class="pointer" (click)="loadData()">
                    {{ 'COMMENTS.CANCEL' | translate }}
                  </small>

                  <small
                    *ngIf="comment.meta_front.edit"
                    class="update-comment pointer d-inline-block ms-3"
                    (click)="updateComment(comment)"
                  >
                    {{ 'COMMENTS.UPDATE' | translate }}
                  </small>
                </div>
              </div>
              <!--<app-reminder-button
                [reminderableId]="comment.id"
                [reminderableType]="LaravelModelsEnum.COMMENT"
              ></app-reminder-button>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <p-paginator
      *ngIf="commentsResponse?.meta?.per_page < commentsResponse?.meta?.total"
      [rows]="commentsResponse.meta.per_page"
      [totalRecords]="commentsResponse.meta.total"
      (onPageChange)="paginate($event)"
    ></p-paginator>
  </div>
</div>
